import { render, staticRenderFns } from "./enquadramento.vue?vue&type=template&id=658503c0&scoped=true&"
import script from "./enquadramento.vue?vue&type=script&lang=js&"
export * from "./enquadramento.vue?vue&type=script&lang=js&"
import style0 from "./enquadramento.vue?vue&type=style&index=0&id=658503c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658503c0",
  null
  
)

export default component.exports